import { hydrateRoot } from 'react-dom/client';

import { Application } from 'shared/containers/App';
import { SuperhostContainer } from 'shared/containers/Superhost';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';

interface IDependencies {
  context: IApplicationContext;
  store: TReduxStore;
}

export function renderApplication(dependencies: IDependencies): void {
  const { context, store } = dependencies;
  const { config } = context;

  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(
    rootElement,
    <Application context={context} reduxStore={store}>
      <SuperhostContainer />
    </Application>,
  );
}
